/*!
=========================================================
* 工事情報詳細
=========================================================
*/
import React from "react";
import {
  Button,
  Card, CardBody, CardHeader, CardTitle,
  Table,  Row,  Col,
} from "reactstrap";
import SystemInfo from '../ViewParts/SystemInfo';
import Request from '../../common/Request';
import StatusChart from '../ViewParts/StatusChart';
import CustomTableTreeDetail from '../ViewParts/CustomTableTreeDetail';
import Definition from '../../common/Definition';
import Format from '../../common/Format';
import {
  cst_request_type,
} from '../../variables/codes_map';
import CustomTd from '../ViewParts/CustomTd';
import WithRole from '../FormParts/ButtonWithRole';
import DialogBase from '../Base/DialogBase';
import InputText from '../FormParts/InputText';
import FormatCode from '../../common/FormatCode';
import InputFile from '../FormParts/InputFile';
import AddMemoPopupInner from "../ViewParts/AddMemoPopupInner";
import AlertModal from "../ViewParts/AlertModal";
import Validate from "../../common/Validate";
import {GetMessage} from "../../variables/message"
import { andpad_json_data, andpad_json_data_estimate } from '../../variables/andpad';

const moment = require("moment");
var domain = "";  
class Detail extends React.Component {
  default_column = [
    {Header: '依頼',accessor:'___JOIN_tree_request',id:'___JOIN_tree_request',headerClassName:'text-center',className:'text-left',minWidth:"200px"}
  ];
  default_sub_column = [
    {Header: '見積',accessor:'___JOIN_tree_estimate',id:'___JOIN_tree_estimate',headerClassName:'sub-table-header',className:'text-left'}
  ];
  constructor(props){
    super(props);

    const box_status = new URL(window.location.href).searchParams.get("box_status")
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${box_status}` 
    // 遷移元に戻るための設定
    const transition_url = box_status === "0" ? "/construction/list" : "/construction/new_customer";

    this.state ={
        title: '工事情報詳細',
        search_url:"/api/construction",
        data:{
          values:{}
        },
        request:[],
        chartData:[],
        project_id:this.props.match.params.project_id,
        column: this.default_column,
        sub_column:this.default_sub_column,
        request_real:[],
        customer1:{},
        customer2:{},
        landmark_branch:{},
        modal:false,
        dialogData:{},
        box_status: box_status,
        box_status_param: box_status_param,
        transition_url: transition_url
    };
    this.Dialog = React.createRef()
    this.dialogCustomerRequestFile = React.createRef();
    this.nodeSelectedCallback = this.nodeSelectedCallback.bind(this);
    this.toggleModal = this.toggleModal.bind(this)
    this.andpadAlertModal = React.createRef();
    const url = domain + '/api/construction/'+this.props.match.params.project_id;
    Request.get(url,{
      project_ulid: this.props.match.params.project_id
    }, res => {
      if (res.data.request.length>0){
        this.handleChartData(res.Data.request[0], 0)
      }
      this.setState({ 
        data: {
          ...this.state.data,
          values:res.Data, 
        },
        request_real:res.Data.request,
      }, ()=>{
        this.setState({
          request: this.dataMap(this.state.request_real),
        })
        this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
        this.InputTextWithRole = WithRole(InputText, this.props.buttons, this.state.data.values)
        this.InputFileWithRole = WithRole(InputFile, this.props.buttons, this.state.data.values)
      }
      )
      
      const customerUserApiEndPoint = '/api/customer/user'
      if (res.Data.customer_user_natural_id){
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id:res.Data.customer_user_natural_id
        }, res=>{
          this.setState({
            customer1: res.Data[0]
          })
        })
      }
      if (res.Data.subcontract_customer_user_natural_id){
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id:res.Data.subcontract_customer_user_natural_id
        }, res=>{
          this.setState({
            customer2: res.Data[0]
          })
        })
      }

      if (res.Data.user_branch_natural_id){
        Request.get('/api/landmark/user_branch', {
          user_branch_natural_id:res.Data.user_branch_natural_id
        }, res=>{
          this.setState({
            landmark_branch: res.Data[0]
          })
        })
      }
    });
  }

  updateRequestRealAndModal = ({ requestIndex, estimateIndex, estimate})=>{
    let newRequestReal = this.state.request_real
    newRequestReal[requestIndex].estimate[estimateIndex] = estimate
    this.setState({
      request_real: newRequestReal,
      request: this.dataMap(newRequestReal),
      dialogData:{
        ...this.state.dialogData,
        estimate:estimate
      }
    })
    this.handleChartData(newRequestReal[requestIndex], requestIndex)
  }

  dataMap(data){
    return data.map((prop, key) => {
      if(prop.request_type < 4){
        return {
          id: key,
          ___JOIN_tree_request: <Button className="btn-link" onClick={()=>this.handleChartData(prop, key)}><div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_tree_request', prop)}} /></Button>,
          children:this.subDataMap(prop.estimate,prop.ulid)
        }
      }else{
        return {
          id: key,
          ___JOIN_tree_request: <Button className="btn-link" onClick={()=>this.handleChartData(prop, key)}><div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_tree_request_other', prop)}} /></Button>,
          // children:this.subDataMap(prop.estimate,prop.ulid)
        }
      }
    });
  }
  subDataMap(data,ulid){
    if(!data){
      return
    }
    return data.map((prop, key) => {
      return {
        _REQUEST__ulid:ulid,
        id: key,
        ___JOIN_tree_estimate:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_tree_estimate', prop)}} />
      }
    });
  }
  
  nodeSelectedCallback(node) {
    // console.log("nodeSelectedCallback", node)
    // console.log(node.props)
    // console.log(node.type)
    //supplier_contract_pdf_url 仕入契約書
    switch(node.type){
      case "request":
          // feature/1590 顧客リクエストファイル対応        
          // console.log("nodeSelectedCallback",this.state.chartRequestData);
          let {
            customer_request_file_flag
          } = this.state.chartRequestData
          if (customer_request_file_flag == false) return;

          this.setState({
            dialogCustomerRequestFileData:{
              ...this.state.dialogCustomerRequestFileData,
              values:this.state.chartRequestData,
            }
          }, () => { this.dialogCustomerRequestFile.current.show() })
          return 
      case "estimate_2nd":
        const {
          latest_pdf_survey_url,
          latest_pdf_route_url,
        } = node.props
        this.setState({
          dialogData: {
            latest_pdf_survey_url,
            latest_pdf_route_url,
            project_tree_memo: true,
            estimate: node.props,
            ref_id : node.props.id,
            ref_request_id : node.props.request_id,
            file_type : "survey",
          }
        })
        this.Dialog.current.state.activeNode = node.type;
        this.Dialog.current.show();
        return
      case "estimate_3rd":
        const {
          latest_pdf_purchase_order_url,
          application_form_upload_flag,
          latest_pdf_application_form_url,
        } = node.props
        this.setState({
          dialogData: {
            latest_pdf_purchase_order_url,
            order_memo: true,
            contract_memo: true,
            estimate: node.props,
            ref_id : node.props.id,
            ref_request_id : node.props.request_id,
            file_type : "order",
            application_form_upload_flag,
            latest_pdf_application_form_url,
          }
        })
        this.Dialog.current.state.activeNode = node.type;
        this.Dialog.current.show();
        return 
      case "estimate_4th-1":
        const {
          latest_pdf_supplier_invoice_url,
        } = node.props
        this.setState({
          dialogData: {
            latest_pdf_supplier_invoice_url
          }
        })
        this.Dialog.current.show();
        return
      case "estimate_4th-2":
          const contract_receive_flag = node.props.invoice && node.props.invoice.contract_receive_flag
          const {
            latest_pdf_plotting_url,
            latest_pdf_quote_url,
            id:estimate_id,
            supplier_contract_pdf_url,
          } = node.props
          this.setState({
            dialogData: {
              latest_pdf_plotting_url,
              latest_pdf_quote_url,
              estimate: node.props,
              ref_id : node.props.id,
              ref_request_id : node.props.request_id,
              file_type : "quote",
              contract_receive_flag,
              estimate_id,
              supplier_contract_pdf_url,
            }
          })
          this.Dialog.current.state.activeNode = node.type;
          this.Dialog.current.show();
          return
      case "estimate_5th-2":
        this.setState({
          dialogData: {
            ref_id : node.props.invoice.id,
            ref_request_id : node.props.request_id,
            file_type : "invoice",
          }
        })
        this.Dialog.current.state.activeNode = node.type;
        this.Dialog.current.show();
        return
      default:
        return ''
    } 
  }
  
  setTable({node}){
    console.log('setTable value changed : type', node.type)
  }
  
  handleChartData(requestData, requestIndex){
    //　1st
    const chartData = {
      name: Format.format_date_en(requestData.request_date) + " " + (cst_request_type.find(element=>element.value==requestData.request_type)).label,
      type:'request',
      ulid: '',
      active: requestData.request_date,
      children: requestData.survey_status==9?[{
        name:(requestData.request_type > 3?"Closed":"調査途中終了"),
        type:'',
        ulid: '',
      }]:
      (requestData.request_type<=3) ? 
      requestData.estimate.map((originalEstimate, estimateIndex)=>{//駐車場
        const estimate = {
          ...originalEstimate,
          requestIndex,
          estimateIndex
        }
        const invoice = estimate.invoice
        const estimateStatus = FormatCode.decode("cst_estimate_status",estimate.estimate_status)
        const paymentestimates = estimate.paymentestimate
        
        const paymentDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_date && new Date(paymentestimate.payment.payment_date)
        })
        const paymentDate = Math.min(...(paymentDateList.filter(exist=>exist)));
        
        const paymentReturnDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_return_date && new Date(paymentestimate.payment.payment_return_date)
        })
        const paymentReturnDate = Math.min(...(paymentReturnDateList.filter(exist=>exist)))

        const paymentCSVDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_csv_upload_date && new Date(paymentestimate.payment.payment_csv_upload_date)
        })
        const paymentCSVDate = Math.min(...(paymentCSVDateList.filter(exist=>exist)))

        const firstPaymentData = paymentestimates[0] && paymentestimates[0].payment
        const paymentFinishDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_finish_date && new Date(paymentestimate.payment.payment_finish_date)
        })

        const paymentFinishDate = Math.min(...(paymentFinishDateList.filter(exist=>exist)))
        const paymentStatusNumber = firstPaymentData && firstPaymentData.payment_status
        const payment_request_status = estimate.payment_request_status && FormatCode.decode("cst_payment_request_status", estimate.payment_request_status)
        const paymentStatus = paymentStatusNumber && FormatCode.decode("cst_payment_status",paymentStatusNumber)
        const invoiceProcessStatus = invoice && FormatCode.decode("cst_invoice_process_status",invoice.invoice_process_status)

        const accounts_receivable = estimate.accounts_receivable
        // console.log(estimate)
          // 2nd
          return {          
            name: (Format.format_date_en(requestData.first_estimate_send_date) + " " +(`(${estimate.survey_parking_name}) `)+(estimate.estimate_status < 3? "" : "送付済")),
            type:'estimate_2nd',
            props:estimate,
            children : [
              // 3rd
              {
                name: Format.format_date_en(estimate.order_process_date) + " " 
                  + ((estimate.estimate_status==4||estimate.estimate_status==5||estimate.estimate_status==8)?'受注':estimateStatus),
                type:'estimate_3rd',
                props:estimate,
                children : 
                  [
                  // 4th
                  ...(paymentStatusNumber?[{
                    name: Format.format_date_en((paymentStatusNumber==1 || paymentStatusNumber==3 || paymentStatusNumber==4)?paymentDate:paymentReturnDate) + " " + payment_request_status,
                    type:'estimate_4th-1',
                    props:estimate,
                    children: paymentStatus&&[
                      // 5th
                      {
                        name : Format.format_date_en(
                          (paymentStatusNumber ==1 ? paymentDate 
                            : paymentStatusNumber==2 ? paymentReturnDate 
                              : paymentStatusNumber==3 ? paymentCSVDate 
                                : paymentFinishDate)) + " " + paymentStatus,
                        type:'payment_5th-1',
                        border: "3px solid #69a90d"
                      }
                    ]
                  }]:[]),
                  ...(estimate.estimate_status == 5 || estimate.estimate_status == 8 || 
                      estimate.estimate_status == 6 && estimate.order_box_status == 3 ||
                      estimate.estimate_status == 6 && estimate.order_box_status == 4 ||
                      estimate.estimate_status == 6 && estimate.order_box_status == 5 ||
                      invoice ? ([{
                    // 4th
                    name: Format.format_date_en(estimate.quote_estimate_senddate) + " 確定見積送付済",
                    type:'estimate_4th-2',
                    props:estimate,
                    children: invoice && invoice.invoice_process_status>1&&[{
                      name: Format.format_date_en((invoice.invoice_process_status==4 || invoice.invoice_process_status==5?invoice.invoice_process_finish_date:invoice.invoice_process_pdf_date)) + " " + invoiceProcessStatus,
                      type:'estimate_5th-2',
                      border: "3px solid #69a90d",
                      props:estimate,
                      children: accounts_receivable && (accounts_receivable.accounts_receivable_status==2 &&[{
                        name: Format.format_date_en(accounts_receivable.receivable_collect_finish_date) + " 回収済",
                        type:'estimate_6th-2',
                        border: "3px solid #69a90d",
                      }] || accounts_receivable.accounts_receivable_status==3 && [{
                        name: Format.format_date_en(accounts_receivable.update_timestamp) + " キャンセル",
                        type:'estimate_6th-2',
                        border: "3px solid #69a90d",
                      }] || accounts_receivable.accounts_receivable_status==4 && [{
                        name: Format.format_date_en(accounts_receivable.update_timestamp) + " 一部キャンセル",
                        type:'estimate_6th-2',
                        border: "3px solid #69a90d",
                      }] ) 
                    }]
                  }]) : [])
                  ]
              }
            ]
          }
      })
      : (()=>{//その他
        const estimate = {
          ...requestData.estimate[0],
          requestIndex,
          estimateIndex:0
        }
        
        const invoice = estimate.invoice
        const paymentestimates = estimate.paymentestimate
        
        const paymentDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_date && new Date(paymentestimate.payment.payment_date)
        })
        const paymentDate = Math.min(...(paymentDateList.filter(exist=>exist)));
        
        const paymentReturnDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_return_date && new Date(paymentestimate.payment.payment_return_date)
        })
        const paymentReturnDate = Math.min(...(paymentReturnDateList.filter(exist=>exist)))
        const firstPaymentData = paymentestimates[0] && paymentestimates[0].payment
        const paymentFinishDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_finish_date && new Date(paymentestimate.payment.payment_finish_date)
        })
        
        const paymentCSVDateList = paymentestimates.map((paymentestimate)=>{
          return paymentestimate.payment.payment_csv_upload_date && new Date(paymentestimate.payment.payment_csv_upload_date)
        })
        const paymentCSVDate = Math.min(...(paymentCSVDateList.filter(exist=>exist)))

        const paymentFinishDate = Math.min(...(paymentFinishDateList.filter(exist=>exist)))
        const paymentStatusNumber = firstPaymentData && firstPaymentData.payment_status
        const payment_request_status = estimate.payment_request_status && FormatCode.decode("cst_payment_request_status", estimate.payment_request_status)
        const paymentStatus = paymentStatusNumber && FormatCode.decode("cst_payment_status",paymentStatusNumber)
        const invoiceProcessStatus = invoice && (invoice.invoice_process_status!==undefined) && FormatCode.decode("cst_invoice_process_status",invoice.invoice_process_status)
        const accounts_receivable = estimate.accounts_receivable ? estimate.accounts_receivable : undefined
        
        return [
          // 4th
          ...(paymentStatusNumber?[{
            name: Format.format_date_en((paymentStatusNumber==1 || paymentStatusNumber==3 || paymentStatusNumber==4)?paymentDate:paymentReturnDate) + " " + payment_request_status,
            type:'estimate_4th-1',
            props:estimate,
            children: paymentStatus&&[
              // 5th
              {
                name : Format.format_date_en(
                  (paymentStatusNumber ==1 ? paymentDate 
                    : paymentStatusNumber==2 ? paymentReturnDate 
                      : paymentStatusNumber==3 ? paymentCSVDate 
                        : paymentFinishDate)) + " " + paymentStatus,
                type:'payment_5th-1',
              }
            ]
          }]:[]),
          ...((invoice) ? [{
            name: Format.format_date_en((invoice.invoice_process_status==4 || invoice.invoice_process_status==5?invoice.invoice_process_finish_date:invoice.invoice_process_pdf_date)) + " " + invoiceProcessStatus,
            type:'estimate_5th-2',
            props:estimate,
            children: accounts_receivable && accounts_receivable.accounts_receivable_status==2&&[{
              name: Format.format_date_en(accounts_receivable.receivable_collect_finish_date) + " 回収済",
              type:'estimate_6th-2',
              border: "3px solid #69a90d",
            }]|| accounts_receivable && accounts_receivable.accounts_receivable_status==3 && [{
              name: Format.format_date_en(accounts_receivable.update_timestamp) + " キャンセル",
              type:'estimate_6th-2',
              border: "3px solid #69a90d",
            }] || accounts_receivable && accounts_receivable.accounts_receivable_status==4 && [{
              name: Format.format_date_en(accounts_receivable.update_timestamp) + " 一部キャンセル",
              type:'estimate_6th-2',
              border: "3px solid #69a90d",
            }]
          }] : [])
          ]
      })()
    }
    this.setState({
      ...this.state,
      chartData,
      chartRequestData:requestData,
    })
  }

  toggleModal(){
    this.setState({
      modal:!this.state.modal
    })
  }
  
  render() {
    const {
      customer1,
      customer2
    } = this.state
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.data.values)
    // console.log('state', this.state)
    return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
                <Row>
                <Col md="6">
                  <CardTitle tag="h3" className="float-left">{this.state.title}</CardTitle>                  
                    {/* <CardTitle tag="h3" className="float-left">{this.state.data.values.site_name}</CardTitle> */}
                </Col>
                <Col md="6">
                    <ButtonWithRole
                      button_id="BTN_A1_03_00770"
                      className="float-right"
                      onClick={() => { this.props.history.push('/construction/update/' + this.state.data.values.ulid + this.state.box_status_param) }}
                    >
                      編集
                    </ButtonWithRole>
                </Col>
                </Row>
            </CardHeader>
            <Col md="11"  className="detail">
              <SystemInfo
                id_title='案件ID'
                id_value={this.state.data.values.project_natural_id}
                update_timestamp={this.state.data.values.update_timestamp}
                update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture}
               />
               <CardTitle tag="h4">管理情報</CardTitle>
                <Table>
                  <tbody>
                    <tr>
                      <CustomTd label='メモ'
                        name='PROJECT__system_memo'
                        copy={false}
                        data={this.state.data.values}
                      />
                    </tr>
                  </tbody>
                </Table>
                <CardTitle tag="h4">案件情報</CardTitle>
                <Table className="tablesorter">
                  <tbody>
                    <tr>
                      {/* <th rowSpan='4' className='text-left'>会社情報</th> */}
                      <CustomTd 
                        label="会社名" 
                        name="CUSTOMER__customer_name" 
                        copy={false}
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="支店名" 
                        name="CUSTOMER_BRANCH__customer_branch_name" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="電話番号" 
                        name="CUSTOMER_BRANCH__customer_branch_tel" 
                        copy={false} 
                        colSpan="3"
                        data={customer1}
                      />                      
                    </tr>
                    <tr>
                      <CustomTd 
                        label="FAX番号" 
                        name="CUSTOMER_BRANCH__customer_branch_fax" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      {/* <th rowSpan='3' className='text-left'>担当者</th> */}
                      <CustomTd 
                        label="顧客担当者" 
                        name="CUSTOMER_USER__customer_user_name" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="携帯電話番号" 
                        name="CUSTOMER_USER__customer_user_tel" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="固定電話番号" 
                        name="CUSTOMER_USER__customer_user_tel2" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="メールアドレス" 
                        name="CUSTOMER_USER__customer_user_email" 
                        copy={false} 
                        colSpan="3"
                        data={customer1} 
                      />
                    </tr>
                  </tbody>
                </Table>
                <Table className="tablesorter">
                  <tbody>
                    <tr>
                      {/* <th rowSpan='4' className='text-left'>下請顧客会社情報</th> */}
                      <CustomTd 
                        label="会社名（下請）" 
                        name="CUSTOMER__customer_name" 
                        copy={false}
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="支店名（下請）" 
                        name="CUSTOMER_BRANCH__customer_branch_name" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="電話番号（下請）" 
                        name="CUSTOMER_BRANCH__customer_branch_tel" 
                        copy={false} 
                        colSpan="3"
                        data={customer2}
                      />                      
                    </tr>
                    <tr>
                      <CustomTd 
                        label="FAX番号（下請）" 
                        name="CUSTOMER_BRANCH__customer_branch_fax" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      {/* <th rowSpan='3' className='text-left'>下請顧客担当者</th> */}
                      <CustomTd 
                        label="顧客担当者（下請）" 
                        name="CUSTOMER_USER__customer_user_name" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="携帯電話番号（下請）" 
                        name="CUSTOMER_USER__customer_user_tel" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="固定電話番号（下請）" 
                        name="CUSTOMER_USER__customer_user_tel2" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                    <tr>
                      <CustomTd 
                        label="メールアドレス（下請）" 
                        name="CUSTOMER_USER__customer_user_email" 
                        copy={false} 
                        colSpan="3"
                        data={customer2} 
                      />
                    </tr>
                  </tbody>
                </Table>
                <Table className="tablesorter">
                  <tbody>
                    {this.state.data.values.register_type === 1 && (
                    <>
                      <tr>
                        <CustomTd 
                          label="現場担当者" 
                          name="PROJECT__site_customer_user_name" 
                          copy={false} 
                          data={this.state.data.values} 
                        />
                      </tr>
                      <tr>
                        <CustomTd 
                          label="現場担当者電話番号" 
                          name="PROJECT__site_customer_user_tel" 
                          copy={false} 
                          data={this.state.data.values} 
                        />
                      </tr>
                    </>
                    )}
                  <tr>
                    {/* <th rowSpan="2">現場情報</th> */}
                    <CustomTd 
                      label="工事番号" 
                      name="PROJECT__construction_number" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="現場名" 
                      name="PROJECT__site_name" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="現場名（カナ）" 
                      name="PROJECT__site_name_kana" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd label='工事開始日'
                      name='PROJECT__project_start_date'
                      copy={false}
                      data={this.state.data.values} />
                  </tr>
                  <tr>
                    <CustomTd label='工事終了日'
                      name='PROJECT__project_finish_date'
                      copy={false}
                      data={this.state.data.values} />
                  </tr>
                  <tr>
                    {/* <th rowSpan="3">現場住所</th> */}
                    <CustomTd
                      label="都道府県" 
                      name="PROJECT__site_prefecture" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="市区町村" 
                      name="PROJECT__site_city" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="番地（町名以降）" 
                      name="PROJECT__site_address" 
                      copy={false} 
                      data={this.state.data.values} 
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="送付先"
                      name="PROJECT__send_destination_type" 
                      copy={false} 
                      data={this.state.data.values}
                    />
                  </tr>
                  <tr>
                    <CustomTd 
                      label="担当支店"
                      name="PROJECT__user_branch_name" 
                      copy={false} 
                      data={this.state.landmark_branch}
                    />
                  </tr>
                </tbody>
              </Table>
              <CardTitle tag="h4">依頼情報</CardTitle>
              <CustomTableTreeDetail 
                column={this.default_column}
                sub_column={this.default_sub_column} 
                data={this.state.request} />
              <CardTitle tag="h4">進捗状況</CardTitle>
              <StatusChart
               nodeSelectedCallback={this.nodeSelectedCallback}
               data={this.state.chartData}
               />
              <Row>
                <Col md="3">
                  <Button color="secondary" onClick={() => {
                    this.props.history.push(this.state.transition_url)
                  }}>一覧に戻る</Button>
                </Col>
              </Row>
            </Col>
          </Card>
        </Col>
      </Row>
      <Dialog
        ref={this.Dialog}
        buttons={this.props.buttons}
        data={this.state.dialogData}
        negative={false}
        negative_label="閉じる"
        updateCallback={this.updateRequestRealAndModal}
        positive_label="アップロードする"
        andpadAlertModal={this.andpadAlertModal}
      />
      <AlertModal ref={this.andpadAlertModal}/>
      <DialogCustomerRequestFileDownload
        ref={this.dialogCustomerRequestFile}
        data={this.state.dialogCustomerRequestFileData}
        positive={false}
        negative_label="閉じる"
      />
    </div>
    );
  }
}


export class Dialog extends DialogBase{
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: this.props.data.estimate&&this.props.data.estimate.survey_parking_name||"　",
      data: {
        values:this.props.data.estimate,
        errors:{},
        requiredData:{}
      },
      buttons:props.buttons,
      cuFiles:[],
      activeNode:""
    });
    this.updateMemo = this.updateMemo.bind(this);
    this.updateMemoSupplier = this.updateMemoSupplier.bind(this);
    this.EstimateDetailDialog = React.createRef();
    this.alertModal = React.createRef();
    this.handleClickAndpadLink = this.handleClickAndpadLink.bind(this);
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props.data) === JSON.stringify(prevProps.data))
      return;
      // ファイル情報（cu_files）取得
      const { ref_id , ref_request_id, file_type } = this.props.data;
      // console.log(this.props.data)
      if(ref_id){
        Request.get('/api/cufile', { ref_id , ref_request_id, file_type }, res => {
          this.setState({
            cuFiles : res.Data
          })
        })
      } else {
        this.setState({
          cuFiles : []
        })
      }
      this.setState({
        data: {
          title: this.props.data.estimate&&this.props.data.estimate.survey_parking_name||"　",
          values: this.props.data.estimate,
          errors:{},
          requiredData:{}
        }
      });

      // 受注の場合、閉じるのボタンを非表示にする
      if(this.props.data.order_memo){
        this.setState({
          default_footer_enable : false
        });
      }else{
        this.setState({
          default_footer_enable : true
        });
      }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();

    this.setState({
    data:{
      values:{
        ...this.state.data.values,
        "survey_pdf":"",
        "survey_pdf_base64":"",
        "route_pdf":"",
        "route_pdf_base64":"",
        "quote_pdf":"",
        "quote_pdf_base64":"",
        "plotting_pdf":"",
        "plotting_pdf_base64":""
      }
    },
    positive:false
    })

    this.toggleModal();
  }

  // 1674 andpad連携
  handleClickAndpadLink =  async (is_delete = false) =>{
    const {
      andpad: andpadData,
      request_natural_id,
      estimate_natural_id,
      quote_available_start_date,
      quote_available_end_date,
      quote_available_change_end_date,
      quote_available_change_start_date,
      survey_parking_name,
      survey_parking_prefecture,
      survey_parking_city,
      survey_parking_address,
      ex_andpad_estimate_delete_flag,
      ex_andpad_quote_delete_flag,
      ex_andpad_plotting_delete_flag,
      parking_data:{
        latitude: latitude,
        longitude: longitude,
      },
      id:estimate_id
    } = this.props.data.estimate || {}
    const moment = require("moment");
    const cu_file_request = await new Promise((resolve, reject)=>{
        const andpadUrl = '/api/cufile'
        let json_data = andpad_json_data
        let estimate_data = andpad_json_data_estimate
        estimate_data["deleted"] = is_delete ? true : false
        estimate_data["layout_file_deleted"] = is_delete ? true : false
        estimate_data["invoice_file_deleted"] = is_delete ? true : false
        estimate_data["parking_estimate_id"] = estimate_natural_id
        estimate_data["parking_start_date"] = moment(quote_available_start_date).format("YYYY-MM-DD")
        estimate_data["parking_end_date"] = moment(quote_available_end_date).format("YYYY-MM-DD")
        if (quote_available_change_start_date && quote_available_change_end_date) {
          estimate_data["changed_parking_start_date"] = moment(quote_available_change_start_date).format("YYYY-MM-DD")
          estimate_data["changed_parking_end_date"] = moment(quote_available_change_end_date).format("YYYY-MM-DD")
        }
        estimate_data["parking_name"] = survey_parking_name
        estimate_data["prefecture_code"] = survey_parking_prefecture
        estimate_data["city"] = survey_parking_city
        estimate_data["street"] = survey_parking_address
        estimate_data["latitude"] = String(latitude)
        estimate_data["longitude"] = String(longitude)
        json_data["parking_requests"][0]["parking_request_id"] = request_natural_id
        json_data["parking_requests"][0]["estimates"] = [estimate_data]	

        const andpadParams = {
          andpad:{
            access_token_key: andpadData.ex_andpad_access_token_key,
            system_id: andpadData.ex_andpad_system_id,
            ex_adnpad_plotting_file_flag: true,
            ex_andpad_quote_file_flag: andpadData.ex_andpad_quote_file_flag == 1 ? true : false,
            estimate_id: estimate_id,
            is_db_update: true,
            json_data
          }
        }
        console.log(andpadParams)
        
        Request.post(andpadUrl, andpadParams, res=> resolve(res), err=> {
          reject(err)
        },undefined, true, false)
      })
      console.log('cu_file_request', cu_file_request)
      const message = cu_file_request.Code == "200" || cu_file_request.Code == "204" ? GetMessage("2417") : 
                        cu_file_request.Code == "819" ? is_delete ? GetMessage("2628") : GetMessage("2630") :  
                        "内容:<br />["+cu_file_request.Code+"]" + cu_file_request.Data.data +"<br />"+ cu_file_request.Data.text;
      const title = cu_file_request.Code == "200" || cu_file_request.Code == "204" ? "処理完了" : "エラーが発生しました。"
      this.props.andpadAlertModal.current.confirmCheck({
        title: title,
        message: message ,
        closeBtn: false
      }, ()=>{
        if(cu_file_request.Code == "200" || cu_file_request.Code == "204"){
          this.props.updateCallback({
            requestIndex : this.state.data.values.requestIndex,
            estimateIndex : this.state.data.values.estimateIndex,
            estimate : {
              ...this.state.data.values,
              ex_andpad_estimate_delete_flag: is_delete ? 1 : 0,
              ex_andpad_plotting_delete_flag: is_delete ? 1 : 0,
              ex_andpad_quote_delete_flag: andpadData.ex_andpad_quote_file_flag == 1 ? is_delete ? 1 : 0 : null,
            }
          })
        }else{
          window.location.reload();
        }

      }, false)

  }
  
  handleClickPositive=()=>{
    const GcsUploadUrl = "/api/gcs_upload/attach"
  
    const { customer_id, 
            request_id,
            id, 
            customer_branch_id, 
            customer_user_id, 
            survey_pdf, 
            survey_pdf_base64, 
            route_pdf, 
            route_pdf_base64,
            quote_pdf,
            quote_pdf_base64,
            plotting_pdf,
            plotting_pdf_base64 } = this.state.data.values;


    const SURVEY = "survey"
    const ROUTE = "route"
    const QUOTE = "quote"
    const PLOTTING = "plotting"
    const SURVEY_AND_ROUTE = "estimate_2nd"
    const QUOTE_AND_PLOTTING = "estimate_4th-2"


    const {
      andpad: andpadData,
    } = this.props.data.estimate || {}

    const is_andpad = andpadData && 
                      andpadData.ex_andpad_use_flag == 1 && 
                      andpadData.ex_andpad_access_token_key != "" &&
                      andpadData.ex_andpad_access_token_key != null &&
                      andpadData.ex_andpad_system_id != "" &&
                      andpadData.ex_andpad_system_id != null &&
                      andpadData.register_type == 1 ? true : false;
    const is_quote = andpadData && andpadData.ex_andpad_quote_file_flag == 1 ? true : false;
    const that = this

    // Make API request
    Request.setProgress(40)
    Request.post(GcsUploadUrl ,getData(),async(res)=>{
      Request.setProgress(0)
      if(res.Code == 200){
        // 1674 andpad連携
        // 区画図アップは必須
        // 確定見積アップは支店設定で有効になっている場合のみ
        if(is_andpad && hasPlotting() || is_andpad && is_quote && hasQuote()){
          await that.handleClickAndpadLink(false)
        }else{
          this.props.andpadAlertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: 2417,
            closeBtn: false
          }, ()=>{
              this.props.updateCallback({
                  requestIndex : this.state.data.values.requestIndex,
                  estimateIndex : this.state.data.values.estimateIndex,
                  estimate : {
                    ...this.state.data.values,
                  }
              })

          }, false)          
        }
      }
    },(err)=>{console.log(err)},closeModal)

    
    // Helper functions
    function hasSurvey(){
      return survey_pdf && survey_pdf_base64 
    }

    function hasRoute(){
      return route_pdf && route_pdf_base64 
    }

    function hasQuote(){
      return quote_pdf && quote_pdf_base64
    }

    function hasPlotting(){
      return plotting_pdf && plotting_pdf_base64
    }

    function getData(){

        if(that.state.activeNode === SURVEY_AND_ROUTE){
          if(hasSurvey() && hasRoute()) return [getParams(SURVEY),getParams(ROUTE)]
          if(hasSurvey() && !hasRoute()) return [getParams(SURVEY)]
          if(!hasSurvey() && hasRoute()) return [getParams(ROUTE)]

        }else if (that.state.activeNode === QUOTE_AND_PLOTTING){
          if(hasQuote() && hasPlotting()) return [getParams(QUOTE),getParams(PLOTTING)]
          if(hasQuote() && !hasPlotting()) return [getParams(QUOTE)]
          if(!hasQuote() && hasPlotting()) return [getParams(PLOTTING)]
        }
    }

    function getParams(fileType){

      let ref_id,exec_report;

      switch (fileType) {
        case SURVEY:
          ref_id = id
          exec_report = "C01"
          break;
        
        case ROUTE:
          ref_id = request_id
          exec_report = "C02"
          break;

        case QUOTE:
          ref_id = id
          exec_report = "F01"
          break;

        case PLOTTING:
          ref_id = id
          exec_report = "F02"
          break;

        default:
          break;
      }
      
      return {
        customer_id,
        ref_id,
        customer_branch_id,
        exec_report,
        customer_user_id,
        fileName:that.state.data.values[`${fileType}_pdf`],
        base64_str:that.state.data.values[`${fileType}_pdf_base64`]
      }
    }
   
    function closeModal(){
      Request.setProgress(0)
      that.handleClickNegative()
    }
  }

  validateCallback=(newData)=>{
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
      positive:true
    })
  }
  // 顧客メモ
  updateMemo(newData){
    let data = this.state.estimate;
    if(newData.add_memo !== undefined){
      // 新規メモのエラーについてはAddMemoPopupInner側で対応しているためここでは不要
      newData.errors = ""
      data = this.state.data
    }
    if(Object.keys(newData.errors).length > 0){
      this.setState({
        data:{
          ...data,
          ...newData
        }
      })
      return;
    }

    this.setState({
      data:{
        ...data,
        ...newData
      }
    }, ()=>{
      // console.log('updateMemo', this.state.data)
      const url = '/api/estimate/memo/'+this.state.data.values.estimate_ulid
      const params = {
        ...this.state.data.values,
        update_timestamp:this.state.data.values.estimate_update_timestamp,
        add_memo: this.state.data.add_memo,
        isOrderMemo: true,
        login_user: localStorage.getItem("name")
      }
      // console.log('updateMemo params', params)
      Request.put(url, params, (res)=>{
        // this.toggleModal();
        // update request_real and refresh data() - only update timestamp?
        // console.log('result', res.Data)
        if (res.Code==200){
          this.props.updateCallback({
            requestIndex : this.state.data.values.requestIndex,
            estimateIndex : this.state.data.values.estimateIndex,
            estimate : {
              ...this.state.data.values,
              order_memo : res.Data.order_memo,
              estimate_update_timestamp: res.Data.update_timestamp
            }
          })
        }
        
      })
    })
    
  }
  // 仕入先メモ
  updateMemoSupplier(data){
    // 無効な文字列チェック
    console.log(data)
		const max_length_validate = Validate.length(data.add_supplier_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}

    const url = '/api/estimate/memo/'+this.state.data.values.estimate_ulid
    const params = {
      update_timestamp:this.state.data.values.estimate_update_timestamp,
      ...this.state.data.values,
      add_memo: data.add_supplier_memo,
      isOrderMemo: false,
      login_user: localStorage.getItem("name")
    }
    Request.put(url, params, (res)=>{
      // this.toggleModal();
      // update request_real and refresh data() - only update timestamp?
      // console.log('result', res.Data)
      if (res.Code==200){
        this.props.updateCallback({
          requestIndex : this.state.data.values.requestIndex,
          estimateIndex : this.state.data.values.estimateIndex,
          estimate : {
            ...this.state.data.values,
            supplier_memo : res.Data.supplier_memo,
            estimate_update_timestamp: res.Data.update_timestamp
          }
        })
      }
      
    })
  }

	viewConstract(estimate_id){
		// ファイル情報取得
    // console.log(estimate_id)
		Request.get('/api/cufile', { ref_id : estimate_id, file_type : 5 }, res => {
			if(res.Code == 200){
				res.Data.map((file, index) => {
          // console.log(file)
					window.open(`/api/gcs_download/${file.file_path}?d=${file.file_name}`);
				})		
			}
		})
	}

  bodyContent(){
    const InputTextWithRole = this.InputTextWithRole || WithRole(InputText, this.props.buttons, this.state.data.values)
    const InputFileWithRole = this.InputFileWithRole || WithRole(InputFile, this.props.buttons, this.state.data.values)
    // console.log(this.state.cuFiles)
    
    // 顧客メモ
    let order_memo = null
    if(this.props.data.estimate){
      order_memo = this.props.data.estimate.order_memo
    }
    const addMemoPopupData = {
      data:{
        ...this.state.data,
        isOrderMemo: true,
        label: "顧客メモ",
        values : {
          order_memo : order_memo
        }
      },
      updateMemo: this.updateMemo
    }
    let supplier_memo = null
    if(this.props.data.estimate){
      supplier_memo = this.props.data.estimate.supplier_memo
    }
    const addMemoPopupSupplierData = {
      data:{
        ...this.state.data,
        isOrderMemo: false,
        label: "仕入先メモ",
        values : {
          supplier_memo : supplier_memo
        }
      },
      updateMemoSupplier: this.updateMemoSupplier
    }
    // 1674 ANDPAD連携
    const {
      andpad: andpadData,
      request_natural_id,
      estimate_natural_id,
      quote_available_start_date,
      quote_available_end_date,
      quote_available_change_end_date,
      quote_available_change_start_date,
      survey_parking_name,
      survey_parking_prefecture,
      survey_parking_city,
      survey_parking_address,
      ex_andpad_estimate_delete_flag,
      ex_andpad_quote_delete_flag,
      ex_andpad_plotting_delete_flag,
      id:estimate_id
    } = this.props.data.estimate || {}
    // console.log(this.state.data)
    // console.log(ex_andpad_quote_delete_flag, ex_andpad_plotting_delete_flag)

    const is_andpad = andpadData && 
                      andpadData.ex_andpad_use_flag == 1 && 
                      andpadData.ex_andpad_access_token_key != "" &&
                      andpadData.ex_andpad_access_token_key != null &&
                      andpadData.ex_andpad_system_id != "" &&
                      andpadData.ex_andpad_system_id != null &&
                      andpadData.register_type == 1 ? true : false;
    const is_quote = andpadData && andpadData.ex_andpad_quote_file_flag == 1 ? true : false;
    const is_quote_linked = ex_andpad_quote_delete_flag != null ? true : false;
    const is_plotting_linked = ex_andpad_plotting_delete_flag != null ? true : false;
    const is_estimate_linked = ex_andpad_estimate_delete_flag != null ? true : false;
    // console.log(is_andpad, is_quote, is_quote_linked, is_plotting_linked, is_estimate_linked)
    return(
      <>
        <Table>
          <tbody>
            <tr>
               <td>
                  リンク
               </td>
               <td>
                {
                  this.props.data.latest_pdf_survey_url
                  &&<>
                    <a 
                      href={`https://drive.google.com/open?id=${this.props.data.latest_pdf_survey_url}`}
                      target="_blank">調査見積書</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.latest_pdf_route_url
                  &&<>
                  <a href={`https://drive.google.com/open?id=${this.props.data.latest_pdf_route_url}`} target="_blank">調査見積時の経路図</a>
                  <br/>
                  </>
                }
                {
                  this.props.data.latest_pdf_purchase_order_url
                  &&<>
                    <a href={`/api/gcs_download/${this.props.data.latest_pdf_purchase_order_url}?d=発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">顧客からの発注書</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.latest_pdf_plotting_url
                  &&<>
                    <a href={`https://drive.google.com/open?id=${this.props.data.latest_pdf_plotting_url}`} target="_blank">契約駐車場の区画図面</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.latest_pdf_quote_url
                  &&<>
                    <a href={`https://drive.google.com/open?id=${this.props.data.latest_pdf_quote_url}`} target="_blank">確定見積書</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.latest_pdf_supplier_invoice_url
                  &&<>
                    <a href={`/api/gcs_download/${this.props.data.latest_pdf_supplier_invoice_url}?d=請求書_${moment().format("YYYYMMDDHHmmss")}`} target="_blank">仕入先からの請求書</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.estimate &&
                  <>
                    <a style={{color: "#ba54f5", fontWeight: 300, cursor: "pointer"}} onClick={()=>{this.EstimateDetailDialog.current.show()}}>見積金額詳細</a>
                    <br />
                  </> 
                }
                {
                  this.props.data.latest_pdf_application_form_url &&
                  (<>
                  {this.props.data.application_form_upload_flag == 0?(
                    <a href={`https://drive.google.com/open?id=${this.props.data.latest_pdf_application_form_url}`} target="_blank">申込書</a>
                  ):(
                    <a href={`/api/gcs_download/${this.props.data.latest_pdf_application_form_url}?d=申込書_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">申込書</a>
                  )}
                  <br />
                  </>)
                }
                {
                  this.state.activeNode === "estimate_4th-2" && this.props.data.estimate && this.props.data.estimate.estimate_status >= 5 && this.state.data.values && this.state.data.values && this.state.data.values.invoice && this.state.data.values.invoice.contract_pdf_url &&
                  <>
                    <a href={`https://drive.google.com/open?id=${this.state.data.values.invoice.contract_pdf_url}`} target="_blank">契約書（捺印前）</a>
                    <br/>
                  </>
                }
                {
                  this.props.data.contract_receive_flag && this.props.data.contract_receive_flag == "1" &&
                  <>
                    <a style={{"cursor":"pointer"}} href="#" onClick={()=>this.viewConstract(this.props.data.estimate_id)}>契約書（捺印済）</a>
                    <br />
                  </>
                }
                {
                  this.props.data.supplier_contract_pdf_url &&
                  <>
                    <a href={`/api/gcs_download/${this.props.data.supplier_contract_pdf_url}?d=仕入契約書_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">仕入契約書</a>
                    <br />
                  </>
                }
               </td>
            </tr>
            {this.state.cuFiles.length > 0 &&
              <tr>
                <td>
                    リンク（顧客向け）
                </td>
                <td>
                  {this.state.cuFiles.map((file) => (
                    <>
                      <a key={file.id} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">
                        {file.file_name}
                      </a>
                      <br/>
                    </>
                  ))}
                </td>
              </tr>
            }
  
            {this.props.data.project_tree_memo && <tr>
              <CustomTd label='工事詳細ツリー表示用メモ'
                name='ESTIMATE__project_tree_memo'
                copy={false}
                rootData={this.state.data}
                value={
                  <InputTextWithRole multiline={true}
                    validateCallback={this.updateMemo} 
                    validateType='regist'
                    button_id="BTN_A1_03_00897"
                  />
                }
              />
            </tr>}
            {this.props.data.latest_pdf_survey_url
                  &&
              <tr>
                <td>
                    調査見積書　アップロード
                </td>
                <td>
                <InputFileWithRole 
                label="調査見積書"
                name="CU_FILE__survey_pdf"
                showLink={false}
                validateCallback={this.validateCallback} 
                rootData={this.state.data} 
                button_id="BTN_A1_03_00882"
               />
                </td>
              </tr>
            }
            {this.props.data.latest_pdf_route_url
                  &&
              <tr>
                <td>
                調査見積時の経路図　アップロード
                </td>
                <td>
                <InputFileWithRole 
                label="駐車場区画図面"
                name="CU_FILE__route_pdf"
                showLink={false}
                validateCallback={this.validateCallback} 
                rootData={this.state.data} 
                button_id="BTN_A1_03_00883"
               />
                </td>
              </tr>
            }
            {this.props.data.latest_pdf_quote_url
                  &&
              <tr>
                <td>
                確定見積書　アップロード
                </td>
                <td>
                <InputFileWithRole 
                label="確定見積書"
                name="CU_FILE__quote_pdf"
                showLink={false}
                validateCallback={this.validateCallback} 
                rootData={this.state.data} 
                button_id="BTN_A1_03_00884"
               />
                </td>
              </tr>
            }
            {this.props.data.latest_pdf_plotting_url
              &&
              <tr>
                <td>
                契約駐車場の区画図面　アップロード
                </td>
                <td>
                <InputFileWithRole 
                label="契約駐車場の区画図面"
                name="CU_FILE__plotting_pdf"
                showLink={false}
                validateCallback={this.validateCallback} 
                rootData={this.state.data} 
                button_id="BTN_A1_03_00885"
               />
                </td>
              </tr>
            }
            {is_andpad == true && is_estimate_linked == true &&
              <>
                <tr>
                  <td style={{position:"relative",padding:"17px 7px"}}>
                      ANDPAD連携
                  </td>
                  <td style={{position:"relative",padding:"17px 7px"}}>
                    <span >
                      {is_plotting_linked == true && <>
                      区画図：{is_estimate_linked == true && ex_andpad_plotting_delete_flag == 0 ? "連携済み" : "連携削除済み"}
                      </>}
                      {is_quote && is_plotting_linked == true && <><br/></>}
                      {is_quote && is_quote_linked == true && <>
                        確定見積書：{is_estimate_linked == true && ex_andpad_quote_delete_flag == 0 ? "連携済み" : "連携削除済み"}  
                      </>}
                    </span>
                    <Button 
                      color="danger"
                      style={{minWidth:"200px",padding:"10px 30px",position:"absolute", right:"0px" , top:"12px"}}
                      onClick={async () => {
                        this.props.andpadAlertModal.current.confirmCheck({message:"ANDPADへのファイル連携の削除をします。よろしいですか？",title:"ANDPAD連携削除確認"},async ()=>{
                          const deleteResult = await this.handleClickAndpadLink(true);
                          this.toggleModal();
                        })
                      }}>
                      ファイル連携削除
                    </Button>
                  </td>
                </tr>
                { quote_available_change_start_date && quote_available_change_end_date &&
                  <tr>
                    <td>
                      契約期間変更
                    </td>
                    <td>
                      {Format.format_date(quote_available_change_start_date)} 〜 {Format.format_date(quote_available_change_end_date)}  
                    </td>
                  </tr>
                }
              </>
            }
          </tbody>
        </Table>
        {this.props.data.order_memo && <><hr/>
          <AddMemoPopupInner
            rootData={addMemoPopupData}
            alertModal={this.alertModal}
            toggleModal={this.toggleModal}
            className={"construction_order_memo"}
            {...this.props}
            unnecessaryCloseCrossButton={true}
          /><AlertModal ref={this.alertModal}/></>
        }
        {this.props.data.contract_memo && <><hr/>
          <AddMemoPopupInner
            rootData={addMemoPopupSupplierData}
            alertModal={this.alertModal}
            toggleModal={this.toggleModal}
            className={"construction_order_memo"}
            {...this.props}
            unnecessaryCloseCrossButton={true}
          /><AlertModal ref={this.alertModal}/></>
        }
        {!this.props.data.order_memo && <hr />}
        {
           this.props.data.estimate && <EstimateDetailDialog
            ref={this.EstimateDetailDialog}
            data={this.props.data.estimate}
            negative={false}
            negative_label="閉じる"
          />
        }
      </>
    );
  }
}

export class EstimateDetailDialog extends DialogBase{
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: "見積金額詳細",
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      },
    });
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props) === JSON.stringify(prevProps))
      return;
      this.setState({
        data: {
          values: this.props.data,
          errors:{},
          requiredData:{}
        }
      });
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.toggleModal();
  }

  define_invoice_parts ( label, data_key, invoice_type, invoice_number) {

    if (!invoice_type || invoice_type == null ) {
        invoice_type = 0
    }
    // console.log(label, data_key, invoice_type, invoice_number)
    let td_value = !invoice_type||invoice_type==0? 
            GetMessage(2036): invoice_type==1?
            FormatCode.decode("cst_invoice_business_type",invoice_type)+" (" + invoice_number+ ")":FormatCode.decode("cst_invoice_business_type",invoice_type)

    return (<>
        <tr>
            <CustomTd label={label + '支払先 適格事業者区分'}
                name={'ESTIMATE__' + data_key +'_business_type'}
                copy={false}
                value={td_value}
            />
        </tr>
    </>)

}


  bodyContent(){
    // console.log(this.state.data.values);
    return(
      <>
        <CardBody style={{overflowY: 'auto', height: '500px'}}>
          <Table>
            <tbody>
              <div className="card-header-estimate-detail">①基本情報</div>
              <tr>
                <CustomTd 
                  label="見積ID" 
                  name="ESTIMATE__estimate_natural_id"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="見積ステータス" 
                  name="ESTIMATE__estimate_status"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="仕入依頼ステータス" 
                  name="ESTIMATE__payment_request_status"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積駐車場情報：駐車場名" 
                  name="ESTIMATE__survey_parking_name"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入先情報：仕入先名" 
                  name="ESTIMATE__supplier_name"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入先情報：仕入先担当者名" 
                  name="ESTIMATE__supplier_user_name"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入先情報：電話番号①" 
                  name="ESTIMATE__supplier_tel"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>

              <div className="card-header-estimate-detail">②調査見積情報</div>
              <div className="card-header-estimate-detail">②-1調査見積　基本情報</div>
              <tr>
                <CustomTd 
                  label="調査見積見積情報：調査見積期間" 
                  name="ESTIMATE__available"
                  copy={false}
                  value={`${Format.format_date(this.state.data.values.survey_available_start_date)}　～　${Format.format_date(this.state.data.values.survey_available_end_date)}`}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積情報：見積台数" 
                  name="ESTIMATE__survey_capacity_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積情報：実質月数" 
                  name="ESTIMATE__survey_month_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積情報：実質日数" 
                  name="ESTIMATE__survey_day_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <div className="card-header-estimate-detail">②-2調査見積　仕入金額</div>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：賃料（月単価）" 
                  name="ESTIMATE__survey_cost_parking_rent"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：手数料" 
                  name="ESTIMATE__survey_cost_commission"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：敷金単価" 
                  name="ESTIMATE__survey_cost_security_deposit"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：礼金単価" 
                  name="ESTIMATE__survey_cost_key_money"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：その他" 
                  name="ESTIMATE__survey_cost_other"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：仕入合計" 
                  name="ESTIMATE__survey_cost_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積仕入金額：敷金合計" 
                  name="ESTIMATE__survey_cost_security_deposit_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              
              <div className="card-header-estimate-detail">②-3調査見積　見積金額</div>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：賃料（月単価）" 
                  name="ESTIMATE__survey_parking_rent"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：上乗せ額" 
                  name="ESTIMATE__survey_parking_rent_profit"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：手数料" 
                  name="ESTIMATE__survey_commission"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：手数料割引率" 
                  name="ESTIMATE__survey_commission_discount_rate"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：実質手数料" 
                  name="ESTIMATE__survey_commission_discount_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：礼金単価" 
                  name="ESTIMATE__survey_key_money"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：税込みフラグ" 
                  name="ESTIMATE__survey_tax_in_flag"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：端数調整フラグ" 
                  name="ESTIMATE__survey_fraction_amt_flag"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：調整金額（実費用）" 
                  name="ESTIMATE__survey_adjustment_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：値引額" 
                  name="ESTIMATE__survey_discount_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              {this.state.data.values.taxble_estimate_detail_name != "" &&(
                <tr>
                <CustomTd 
                    label={"その他課税項目：" + this.state.data.values.taxble_estimate_detail_name}
                    name="ESTIMATE_DETAIL__taxble_estimate_detail_amt"
                    copy={false}
                    data={this.state.data.values}
                  />
                </tr>
              )}
              {this.state.data.values.non_taxble_estimate_detail_name != "" &&(
                <tr>
                <CustomTd 
                    label={"その他非課税項目：" + this.state.data.values.non_taxble_estimate_detail_name}
                    name="ESTIMATE_DETAIL__non_taxble_estimate_detail_amt"
                    copy={false}
                    data={this.state.data.values}
                  />
                </tr>
              )}
              <tr>
                <CustomTd 
                  label="調査見積見積金額：見積小計" 
                  name="ESTIMATE__survey_subtotal_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：税額" 
                  name="ESTIMATE__survey_tax_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="調査見積見積金額：見積合計" 
                  name="ESTIMATE__survey_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <div className="card-header-estimate-detail">③確定見積情報</div>
              <div className="card-header-estimate-detail">③-1 確定見積　基本情報</div>
              <tr>
                <CustomTd 
                  label="確定見積期間" 
                  name="ESTIMATE__quote_available"
                  copy={false}
                  value={`${Format.format_date(this.state.data.values.quote_available_start_date)}　～　${Format.format_date(this.state.data.values.quote_available_end_date)}`}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積台数" 
                  name="ESTIMATE__quote_capacity_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積：実質月数" 
                  name="ESTIMATE__quote_month_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積：実質日数" 
                  name="ESTIMATE__quote_day_qty"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積：非課税対象" 
                  name="ESTIMATE__non_taxable_flag"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <div className="card-header-estimate-detail">③-2 確定見積　仕入金額</div>
              <tr>
                <CustomTd 
                  label="確定見積仕入：調整額（単価）" 
                  name="ESTIMATE__quote_cost_adjustment"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="仕入の追金" 
                  name="ESTIMATE__add_cost_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="敷金の追金" 
                  name="ESTIMATE__add_cost_security_deposit_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積仕入：仕入合計" 
                  name="ESTIMATE__quote_cost_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積仕入：敷金合計" 
                  name="ESTIMATE__quote_cost_security_deposit_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <div className="card-header-estimate-detail">③-3 確定見積　見積金額</div>
              <tr>
                <CustomTd 
                  label="確定見積：見積小計" 
                  name="ESTIMATE__quote_subtotal_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積：税額" 
                  name="ESTIMATE__quote_tax_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <tr>
                <CustomTd 
                  label="確定見積：合計額" 
                  name="ESTIMATE__quote_total_amt"
                  copy={false}
                  data={this.state.data.values}
                />
              </tr>
              <div className="card-header-estimate-detail">④適格事業者情報</div>
                {this.state.data.values.survey_cost_parking_rent == "0" 
                ? "" 
                :this.state.data.values.survey_cost_parking_rent_payment_type == 1 
                  ? (<>
                    {this.define_invoice_parts("賃料",
                        "survey_cost_parking_rent",
                        this.state.data.values.survey_cost_parking_rent_invoice_business_type,
                        this.state.data.values.survey_cost_parking_rent_invoice_registration_number
                    )}
                    </>)
                  :this.state.data.values.survey_cost_parking_rent_payment_type == 0
                    ? (<>
                      {this.define_invoice_parts("賃料",
                        "survey_cost_parking_rent",
                        this.state.data.values.supplier_data.supplier_invoice_business_type,
                        this.state.data.values.supplier_data.supplier_invoice_registration_number
                      )}
                      </>)
                    :(<>
                      {this.define_invoice_parts("賃料",
                        "survey_cost_parking_rent",
                        null,
                        null
                      )}
                      </>)
                }
                {this.state.data.values.survey_cost_commission == "0" 
                  ? "" 
                  :this.state.data.values.survey_cost_commission_payment_type == 1 
                    ? (<>
                        {this.define_invoice_parts("手数料",
                            "survey_cost_commission",
                            this.state.data.values.survey_cost_commission_invoice_business_type,
                            this.state.data.values.survey_cost_commission_invoice_registration_number
                        )}
                      </>)
                    : this.state.data.values.survey_cost_commission_payment_type == 0
                      ? (<>
                        {this.define_invoice_parts("手数料",
                            "survey_cost_commission",
                            this.state.data.values.supplier_data.supplier_invoice_business_type,
                            this.state.data.values.supplier_data.supplier_invoice_registration_number
                        )}
                        </>)
                      : (<>
                        {this.define_invoice_parts("手数料",
                          "survey_cost_commission",
                          null,
                          null
                        )}
                        </>)
                }
                {this.state.data.values.survey_cost_key_money == "0" 
                  ? "" 
                  : this.state.data.values.survey_cost_key_money_payment_type == 1 
                    ? (<>
                      {this.define_invoice_parts("礼金",
                          "survey_cost_key_money",
                          this.state.data.values.survey_cost_key_money_invoice_business_type,
                          this.state.data.values.survey_cost_key_money_invoice_registration_number
                      )}
                      </>)
                    : this.state.data.values.survey_cost_key_money_payment_type == 0
                      ? (<>
                        {this.define_invoice_parts("礼金",
                            "survey_cost_key_money",
                            this.state.data.values.supplier_data.supplier_invoice_business_type,
                            this.state.data.values.supplier_data.supplier_invoice_registration_number
                        )}
                        </>)
                      : (<>
                        {this.define_invoice_parts("礼金",
                          "survey_cost_key_money",
                          null,
                          null
                        )}
                        </>)
                }
                {this.state.data.values.survey_cost_other == "0" 
                  ? "" 
                  : this.state.data.values.survey_cost_other_payment_type == 1 
                    ? (<>
                      {this.define_invoice_parts("その他",
                          "survey_cost_other",
                          this.state.data.values.survey_cost_other_invoice_business_type,
                          this.state.data.values.survey_cost_other_invoice_registration_number
                      )}
                      </>)
                    : this.state.data.values.survey_cost_other_payment_type == 0
                      ? (<>
                        {this.define_invoice_parts("その他",
                            "survey_cost_other",
                            this.state.data.values.supplier_data.supplier_invoice_business_type,
                            this.state.data.values.supplier_data.supplier_invoice_registration_number
                        )}
                        </>)
                      : (<>
                        {this.define_invoice_parts("その他",
                          "survey_cost_other",
                          null,
                          null
                        )}
                        </>)
              }   
            </tbody>
          </Table>
        </CardBody>
      </>
    );
  }
}

export class DialogCustomerRequestFileDownload extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '添付ファイルダウンロード',
      data: this.props.data,
      cuFiles : []
      // disablePositive:false
    });
    this.validateCallback = this.validateCallback.bind(this)

    this.CU_FILE_TYPE = 2;
    this.CU_FILE_DETAIL_TYPE = 201;
  }

  async componentDidUpdate(prevProps){
    const {CU_FILE_TYPE,CU_FILE_DETAIL_TYPE} = this

    if (prevProps.data !== this.props.data){

      // ファイル情報取得
      Request.get('/api/cufile', { ref_id : this.props.data.values.id, file_type: CU_FILE_TYPE }, res => {
        this.setState({
          cuFiles : res.Data
        })
      })

      this.setState({
        data: {
          values:{
            ...this.props.data.values,
            send_upload_notification:false
          },
          errors:{
            invoice:[GetMessage(2024)]
          },
          requiredData:{
            invoice:[GetMessage(2024)],
          }
        },
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
    }, ()=>callback())
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.setState({
      data:{
        ...this.state.data,
      }
    })

    this.toggleModal()
  }
  bodyContent() {
    return (
      <>
        {this.state.cuFiles.map((file, index) => (
          <Row key={index}>
              <Col>
                <a className={file.status === 0 ? "disabled-link":""} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">{file.file_name}</a>      
              </Col>
          </Row>
        ))}
        <br/>
      </>
    );
  }
}

export default Detail;